import requestApi from "@/utils/requestApi";
import { uuid } from "@/utils/utils";

export const preOrdergenerate = async ({ cartItemReqFormList, relationOrderId, vueThis }) => {
  const loading = vueThis.$loading({
    lock: false,
    text: "提交中...",
  });

  const { exception, code } = await requestApi.post("sctrading/order/confirm", {
    sources: 0,
    relationOrderId,
    cartItemReqFormList,
  });

  if (code == "0") {
    const subkey = {
      sources: 0,
      cartItemReqFormList: JSON.stringify(cartItemReqFormList),
    };

    const uuidStr = uuid();
    sessionStorage.setItem(uuidStr, JSON.stringify(subkey));
    window.location.href = `${process.env.VUE_APP_APP}v2/order/buyer/orderSubmit?subkey=${uuidStr}&relationOrderId=${relationOrderId}`;
  } else {
    vueThis.$message({
      type: "error",
      message: exception,
    });
  }

  loading.close();
}